/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_50_DescInputs */

const es_gift_option_50_desc = /** @type {(inputs: Gift_Option_50_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal para los que aún se marean en el pantalán.`)
};

const gl_gift_option_50_desc = /** @type {(inputs: Gift_Option_50_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal para os que aínda se marean no pantalán.`)
};

const en_gift_option_50_desc = /** @type {(inputs: Gift_Option_50_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal for those who still feel queasy on the pontoon.`)
};

/**
* | output |
* | --- |
* | "Ideal for those who still feel queasy on the pontoon." |
*
* @param {Gift_Option_50_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_50_desc = /** @type {((inputs?: Gift_Option_50_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_50_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_50_desc(inputs)
	if (locale === "en") return en_gift_option_50_desc(inputs)
	return es_gift_option_50_desc(inputs)
});